import React, {useState, useEffect} from 'react';
import {NewPlanSchema, PlanGetSchema} from '../../api/DBSchema/Plan';
import Api from '../../api/SMPFetchHelper';
import {useSMCSnackbar} from '../../utils/hooks';
import {useSMCErrorHandler} from '../../utils/errorUtils';
import SMCLabel from '../../components/Simple/SMCLabel';
import SMCModal from '../../components/core/SMCModal';
import {useTranslation} from 'react-i18next';
import {ObjectTypes} from '../../api/consts';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody';
import SMCTextInput from '../../components/Simple/SMCTextInput';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCButton from '../../components/Simple/SMCButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

function PlanCloneModal({
    isOpen,
    onRequestClose,
    onSuccess,
    originalObject,
    originalName
}) {
    const { t } = useTranslation();
    const { enqueueErrorSnackbar } = useSMCSnackbar();
    const { getErrorMessage } = useSMCErrorHandler();

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    const onFinish = async () => {
        const createPlanRequestObj = {
            [NewPlanSchema.name]: name,
            [NewPlanSchema.description]: description,
        }

        try {
            const res = await Api.cloneObject(ObjectTypes.PLAN, createPlanRequestObj, originalName);
            if (res.data && res.data.name) {
                if (name === res.data.name) {
                    onSuccess(name, null);
                } else {
                    enqueueErrorSnackbar(t('SMP.PLAN.CREATE_NEW_PLAN_GENERAL_ERROR'));
                }
            }
        } catch (e) {
            const errorMessage = getErrorMessage(e);
            if (errorMessage) {
                enqueueErrorSnackbar(errorMessage);
            } else {
                enqueueErrorSnackbar(t('SMP.PLAN.CREATE_NEW_PLAN_GENERAL_ERROR'));
            }
        }
    }

    useEffect(() => {
        if (isOpen) {
            setName('');
            setDescription(originalObject?.[PlanGetSchema.pages.general.pageId]?.[PlanGetSchema.pages.general.description] || '');
        }
    }, [isOpen, originalObject])

    return (
        <SMCModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            width={650}
            height={620}
            title={t('SMP.PLAN.CREATE_NEW_PLAN')}
        >
            <SMCModalBody>
                <SMCLabel>{t('SMP.PLAN.CREATE_NEW_PLAN.SELECT_NAME_FOR_NEW_PLAN')}</SMCLabel>
                {/* Name */}
                <SMCTextInput
                    value={name}
                    onChange={e => setName(e.target.value)}
                    label={t('SMC_GATEWAY_NAME')}
                />
                {/* Description */}
                <SMCTextInput
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    label={t('SMC_GATEWAY_DESCRIPTION')}
                />
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={onFinish} style={{ marginRight: 5 }}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_FINISH')}
                </SMCButton>
                <SMCButton onClick={onRequestClose}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>
    );
}

export default PlanCloneModal;